import {Doughnut} from "vue-chartjs";
import updateChartMixin from "@/components/widgets/updateChartMixin";

export default {
    extends: Doughnut,
    mixins: [updateChartMixin],
    props: {
        options: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            pending: 0,
            rejected: 0,
            cancelled: 0,
            approved: 0,
            all: 0,
            deleted: 0,
            pax_cancelled: 0,
            system_cancelled: 0,
            unique_fake_reject: 0
        };
    },
    computed: {
        data() {
            if (!this.all) this.all = 1;
            return {
                datasets: [{
                    data: [this.pending, this.deleted, this.rejected, this.approved, this.cancelled, this.pax_cancelled, this.system_cancelled, this.unique_fake_reject],
                    backgroundColor: ["#8e71c7", '#ff8080', "red", "green", "#ff7600", '#ff9940', '#ad6221', '#8B0000']
                }],
                labels: [
                    `P  (${Math.round(this.pending / this.all * 100)}%)`,
                    `D  (${Math.round(this.deleted / this.all * 100)}%)`,
                    `R (${Math.round(this.rejected / this.all * 100)}%)`,
                    `A (${Math.round(this.approved / this.all * 100)}%)`,
                    `C (${Math.round(this.cancelled / this.all * 100)}%)`,
                    `PC. (${Math.round(this.pax_cancelled / this.all * 100)}%)`,
                    `SC (${Math.round(this.system_cancelled / this.all * 100)}%)`,
                    `UFR (${Math.round(this.unique_fake_reject / this.all * 100)}%)`,
                ]
            }
        }
    },
    methods: {
        set(data) {
            this.all = data.all;
            this.pending = data.pending;
            this.rejected = data.rejected;
            this.approved = data.approved;
            this.cancelled = data.cancelled;
            this.pax_cancelled = data.pax_cancelled;
            this.system_cancelled = data.system_cancelled;
            this.unique_fake_reject = data.unique_fake_reject;
            this.deleted = data.deleted;
            this.renderChart(this.data, this.options);
        },
        newAction(pending, rejected, cancelled, approved, pax_cancelled = 0, system_cancelled = 0, deleted = 0) {
            if (pending > 0) {
                this.all++;
            }
            this.pending += pending;
            this.rejected += rejected;
            this.approved += approved;
            this.cancelled += cancelled;
            this.pax_cancelled += pax_cancelled;
            this.system_cancelled += system_cancelled;
            this.deleted += deleted;
            this.renderChart(this.data, this.options);
        }
    },
};